module.exports = __webpack_public_path__ + "img/pnud_logo.bd809814.png";